import { render, staticRenderFns } from "./MyItems.vue?vue&type=template&id=ba4014fe&scoped=true&"
import script from "./MyItems.vue?vue&type=script&lang=js&"
export * from "./MyItems.vue?vue&type=script&lang=js&"
import style0 from "./MyItems.vue?vue&type=style&index=0&id=ba4014fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4014fe",
  null
  
)

export default component.exports